import { get, ref } from 'firebase/database';
import { database } from '../firebase';

type Address = { address: string };

export const getAddresses: () => Promise<Address[]> = async () => {
    let addresses: Address[] = [];

    await get(ref(database, 'addresses')).then((snapshot) => {
        if (snapshot.exists()) {
            snapshot.forEach((childSnapshot) => {
                const address: string = childSnapshot.val();
                addresses.push({ address: address });
            });
        }
    });

    return addresses;
};
